import { Component, OnInit } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { Store } from '@ngrx/store'
import { ActionFailed, positive } from '@tokeet-frontend/utility'
import { SaveForm, Toaster } from '@tokeet/tv3-platform'
import { AiResponderService } from '@tv3/containers/ai-responder/store/ai-responder.service'

@Component({
  selector: 'app-ai-auto-credit-recharge',
  templateUrl: './ai-auto-credit-recharge.component.html',
  styleUrls: ['./ai-auto-credit-recharge.component.scss'],
})
export class AiAutoCreditRechargeComponent implements OnInit {
  settingsForm = this.fb.group({
    recharge_balance: [50, [positive(), Validators.required]],
    recharge_threshold: [10, [positive(), Validators.required]],
  })
  rechargeForm = this.fb.group({
    recharge_amount: [50, [positive(), Validators.min(5), Validators.required]],
  })
  isRecharging = false

  constructor(
    private fb: FormBuilder,
    private store: Store<any>,
    private toaster: Toaster,
    private aiService: AiResponderService
  ) {}

  ngOnInit(): void {
    this.aiService.getAccountAISettings().subscribe((data) => {
      this.settingsForm.patchValue(data || {})
    })
  }

  @SaveForm()
  onSave(form: FormGroup) {
    const payload = this.settingsForm.getRawValue()
    this.aiService.setAccountAISettings(payload).subscribe(
      () => {
        this.toaster.success('Settings updated successfully!')
      },
      (error) => {
        this.store.dispatch(ActionFailed({ error }))
      }
    )
  }

  @SaveForm()
  onCharge(form: FormGroup) {
    this.isRecharging = true
    const payload = this.rechargeForm.getRawValue()
    this.aiService.recharge(payload.recharge_amount).subscribe(
      () => {
        this.isRecharging = false
        this.toaster.success('Recharged successfully!')
      },
      (error) => {
        this.isRecharging = false
        this.store.dispatch(ActionFailed({ error }))
      }
    )
  }
}
